export const step = 2;

// Should be same for interval and actions at least for RT Load
// otherwise graph changing time period incorrect
export const MINUTE_IN_MILLISECONDS = 60000; // 1 minute
export const REAL_TIME_INTERVAL = MINUTE_IN_MILLISECONDS; // 1 minute
export const PERIOD_FOR_HISTORY = 3; // 3 hours
export const PERIOD_FOR_UPDATE = 2; // 2 minutes

export const measurementTypes = {
  POWER: 'POWER_BASED',
  LOAD: 'LOAD_BASED',
};
